<div class="personal-main-container">
  <div class="personal-main-nav-bar box">
    <div class="personal-main-nav-bar-title">ساخت غذای من</div>
    <div class="personal-main-back img-holder" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="personal-main-top box">
    <div class="wrapper pb24">
      <p class="primary">اطلاعات غذا</p>
      <div class="input-wrapper">
        <input
          type="text"
          [(ngModel)]="foodname"
          (input)="change()"
          placeholder="نام غذا را وارد کنید..."
        />
      </div>
      <div *ngIf="foodUnitArray">
        <div
          class="input-wrapper"
          *ngFor="let f of foodUnitArray"
          (click)="updateSelect(f)"
        >
          <p class="select">{{ f[1].name }}</p>
          <p class="unit">{{ f[0].ratio }} گرم</p>
        </div>
      </div>
    </div>
    <div class="addBtn" (click)="newFoodRatio()">
      <div class="inner">
        <div class="icon">
          <img src="assets/plan/plus.svg" alt="" />
        </div>
        <p>افزودن واحد و مقدار غذای شخصی</p>
      </div>
    </div>
    <div class="wrapper">
      <p>جدول ارزش غذایی ( به ازای هر ۱۰۰ گرم)</p>
      <div class="input-wrapper">
        <p class="unit" [ngClass]="{ 'unit-secondary': calorie == null }">
          کالری
        </p>
        <label for="" *ngIf="calorie !== null">کالری</label>

        <input
          type="tel"
          (input)="change()"
          [(ngModel)]="calorie"
          placeholder="*مقدار کالری"
        />
      </div>
    </div>
    <div class="wrapper" style="margin-bottom: 96px">
      <p>جزییات بیشتر</p>
      <div
        class="input-wrapper"
        *ngFor="let name of foodFactsNames; let i = index"
      >
        <label for="" *ngIf="foodFactsAmount[i] !== null">{{ name }}</label>
        <p
          class="unit"
          [ngClass]="{ 'unit-secondary': foodFactsAmount[i] == null }"
        >
          {{ foodFactsUnits[i] }}
        </p>
        <input
          type="tel"
          [(ngModel)]="foodFactsAmount[i]"
          placeholder="{{ ' مقدار ' + name + '...' }}"
        />
      </div>
    </div>
  </div>
  <div class="navbar-bottom">
    <div
      class="success"
      *ngIf="!edit"
      (click)="submit()"
      [ngClass]="{ blue: ready }"
    >
      ثبت
    </div>
    <div
      class="success"
      *ngIf="edit"
      (click)="update()"
      [ngClass]="{ blue: ready }"
    >
      ثبت
    </div>

    <div class="cancel" *ngIf="!edit" (click)="cancel()">انصراف</div>
    <div class="cancel" *ngIf="edit" (click)="delete()">حذف</div>
  </div>
</div>
<app-personal-bottomsheet
  *ngIf="bottomSheetUnint"
  [show]="bottomSheetUnintShow"
></app-personal-bottomsheet>
